import meMessages from '../locales/sr_ME.json';

const MeLang = {
  messages: {
    ...meMessages,
  },
  locale: 'sr-ME',
};
export default MeLang;
